__turbopack_context__.v({
  "circle": "dnWDRa_circle",
  "container": "dnWDRa_container",
  "svg": "dnWDRa_svg",
});
